/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function PoliciesAndCircularsInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Policies and Circulars"
              description={
                <>
                  <h4>The following are Elections Nova Scotia policies that impact external stakeholders as well as circulars that provide Elections Nova Scotia’s position or interpretation of certain issues.</h4>
                  <br />
                  <h3>Elections Nova Scotia Policies</h3>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="/files/PoliciesAndCirculars/2023_Policy_CampaignAccessMultiunitBuidlings_V2_FINAL.pdf">Campaign Access to Multi-unit Buildings Policy</a> - <a href="/files/PoliciesAndCirculars/CAMB_Policy_FSQA_Final.pdf">Fact sheet and Q&A</a></li>
                    <br /><li><a href="/files/PoliciesAndCirculars/CESP_Policy_2024_V2.pdf">Candidate Electoral Support Program (CESP) Policy</a> - <a href="/files/PoliciesAndCirculars/CESP_FactSheet_2021.pdf">Fact sheet, Q&A, and application form</a></li>
                    <br /><li><a href="/files/PoliciesAndCirculars/2023_Policy_CandidateNameAppearance_V2_FINAL.pdf">Candidate Name Appearance Policy</a> - <a href="/files/PoliciesAndCirculars/CNAP_FactSheetQA_FINAL.pdf">Fact sheet and Q&A</a></li>
                    <br /><li><a href="/files/PoliciesAndCirculars/2026_Policy_WorkerExpenseClaim_V4Final.pdf">Election Worker Expense Claim Policy</a></li>
                    <br /><li> French Language Policy – available in <a href="/files/PoliciesAndCirculars/2020_12_07_FrenchLanguagePolicy_InFrench_FINAL.pdf">French</a> and in <a href="/files/PoliciesAndCirculars/2023_FrenchLanguagePolicy_V2_FINAL.pdf">English</a></li>
                    <br /><li><a href="/files/PoliciesAndCirculars/ENS_Policy_digitalsignature_2026_FINAL.pdf"> Prescribed Electronic Signatures for Financial Report Submissions to Elections Nova Scotia </a></li>
                    <br /><li><a href="/privacy-policy">Privacy Protection Policy and Privacy Protection Guidelines for Political Entities</a></li>
                    <br /><li><a href="/files/PoliciesAndCirculars/SocialMediaPolicy.pdf"> Social Media Policy </a></li>
                  </ul>

                  <br />
                  <h3>Elections Nova Scotia Interpretation Circulars</h3>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                  <li><a href="/files/PoliciesAndCirculars/InterpretationCircular_Section307_2024.pdf">Interpretation Circular of Section 307</a> of the <a href="http://nslegislature.ca/legc/statutes/elections.pdf"><em>Elections Act</em></a> - Circular 24-01, published July 8, 2024.</li><br />
                  <li><a href="/files/PoliciesAndCirculars/Circular16-04PublicOpinionPolls20161130.pdf">Election Public Opinion Polls&nbsp;Interpretation Circular 16-04, November 30, 2016</a></li><br />
                  <li><a href="/files/PoliciesAndCirculars/Circular16-03Loans20161130.pdf">Loans &amp; Loan Defaults Interpretation Circular 16-03, November 30, 2016</a></li><br />
                  <li><a href="/files/PoliciesAndCirculars/Circular16-02ElectionAdvertising_V32026.pdf">Election Advertising Interpretation Circular 16-02, November 30, 2016</a> (Version 3: Updated September 2026 – to reflect legislative Amendments)</li><br />
                  <li><a href="/files/PoliciesAndCirculars/Circular16-01CrowdsourceFunding20161130.pdf">Crowdsource Funding Interpretation Circular 16-01, November 30, 2016</a></li><br />
                  <li><a href="/files/PoliciesAndCirculars/circular1302.pdf">Election Expenses Circular 13-02, September 25, 2013</a></li><br />
                  <li><a href="/files/PoliciesAndCirculars/circular1201.pdf">Hospitality Suite Expenses Circular 12-01, November 8, 2012</a></li><br />
                  {/* <li><a href="/files/PoliciesAndCirculars/Notice%20to%20banks%20and%20credit%20unions.pdf">Notice to Banks and Credit Unions</a></li> */}
                  </ul>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default PoliciesAndCircularsInformation;
